<template>
	<a class="comment-count" :class="classAddons" :href="href">
		{{ count }}
		<SuiIcon name="icon-chat-16" />
	</a>
</template>

<script setup lang="ts">
import { type Task } from '@/generated/graphql';
import { SuiIcon } from '@developers/scoro-ui';
import { computed } from 'vue';

export type CommentCountProps = {
	count: Task['commentsCount'];
	href: string;
	isDone?: boolean;
};

const props = defineProps<CommentCountProps>();

const classAddons = computed(() => ({
	'comment-count--is-done': props.isDone,
}));
</script>

<style lang="scss">
.comment-count {
	--sui-icon-fill: #{$neutral-60};

	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5rem;

	&--is-done {
		--sui-icon-fill: #{$neutral-50};

		color: $neutral-70;
	}

	&:hover {
		--sui-icon-fill: #{$neutral-70};
	}
}
</style>
